import React from 'react';
import searchStrings from 'owa-strings/owa-mini-extension-strings';
const searchIllustration = require('../images/search.svg');
const styles = require('./ZeroSearch.scss');

interface ZeroSearchProps {
    className?: string;
}

export function ZeroSearch({ className = '' }: ZeroSearchProps): JSX.Element {
    return (
        <div className={`${styles.searchImageContainer} ${className}`}>
            <img
                src={searchIllustration}
                alt={searchStrings.zeroSearchIllustrationAlt}
                className={styles.searchImage}
            />
            <div className={styles.primarySearchText}>{searchStrings.zeroSearchQueryTitle}</div>
            <div className={styles.secondarySearchText}>
                {searchStrings.zeroSearchQueryDescription}
            </div>
        </div>
    );
}
